<template>
  <div class="container"></div>
</template>

<script>
import { loginVIP } from '@/api/index'
import Cookies from 'js-cookie'
export default {
  computed: {
    nickname() {
      return this.$route.query.nickname
    },
    user() {
      return this.$route.query.user
    },
  },
  created() {
    const { user, nickname } = this
    if (!user) return
    Cookies.set(
      'vipInfo',
      JSON.stringify({
        user,
        nickname: nickname && nickname != 'undefined' ? nickname : undefined,
      })
    )
    loginVIP(user, nickname).then(({ data }) => {
      const { token } = data
      Cookies.set('token', token)
      this.$store.commit('SET_LOGIN', true)
      this.$router.push('/resources?category=10')
    })
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
}
</style>
